import React from "react";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EventIndicator from "./EventIndicator";
import "../../style/DailySchedule.css";

const formatDate = (dateString) => {
  const options = { month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString("en-US", options);
};

const DailySchedule = ({ date, events, onClose, tags }) => {
  return (
    <div className="daily-schedule-panel">
      <div className="header">
        <h2>{formatDate(date)}'s Schedule</h2>
        <CloseIcon className="close-icon" onClick={onClose} />
      </div>
      <hr />
      <div className="events-list">
        {events.length > 0 ? (
          events.map(event => <EventIndicator key={event.event_id} event={event} tags={tags}/>)
        ) : (
          <p>No events scheduled.</p>
        )}
      </div>
      <hr />
      {/* <button className="schedule-add-event-btn">
        <AddIcon /> Add event
      </button> */}
    </div>
  );
};

export default DailySchedule;